import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CloseIcon } from './Styles/Icons';
import { Dialog, DialogActions, DialogTitle, DialogContent, ButtonGroup, Button, ButtonWithLoader, CircularButton, FlexRow } from './Styles/ViewRejectionDialogBox';
import { Theme } from '../Styles';

import { clearRejectedInventoryItem } from '../../actions/inventoryActionsV2';

// Shown from the inventory row's "View" link once an ingestion-pipeline item's change has been
// rejected - either by the AI reviewer (AI_REJECTED/DLQ_FAILED) or by a human reviewer's own reject
// (metadata.manual_review_status, a separate key so the two sources never get conflated - see
// internal-api's bulkActionByIds/handleAiReviewCompleted). See PostgresSyncService.js (sellerportal)
// for what "clear" actually does: it only ever deletes the stuck pending doc, the product itself was
// never touched by the rejected attempt, so there's nothing else to roll back.
const ViewRejectionDialogBox = ({ open, item, onTrue, onFalse, clearRejectedInventoryItem }) => {
	const [clearing, setClearing] = useState(false);

	const onClearHandler = async () => {
		setClearing(true);
		await clearRejectedInventoryItem(item.supplier_product_id);
		setClearing(false);
		await onTrue();
	};

	useEffect(() => {
		setClearing(false);
	}, [open]);

	if (!item) return null;

	const { ai_review_error, ai_review_completed_at, manual_review_status, manual_review_reason, rejected_by } = item.metadata || {};
	const isManualRejection = manual_review_status === 'REJECTED';

	return (
		<Dialog maxWidth='sm' fullWidth open={open} onClose={() => (clearing ? null : onFalse())}>
			<DialogTitle>
				{isManualRejection ? 'Rejected by Reviewer' : 'System Rejected'}
				<ButtonGroup alignRight>
					<CircularButton error outline disabled={clearing} onClick={() => onFalse()}>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent style={{ marginTop: '-30px' }}>
				<FlexRow style={{ padding: '0 1rem' }}>
					Item ID: <b>&nbsp;{item.supplier_product_id}</b>
				</FlexRow>
				<FlexRow style={{ padding: '0.5rem 1rem 0' }}>
					<span style={{ color: Theme.red }}>
						{isManualRejection ? manual_review_reason : ai_review_error || 'The system reviewer rejected this change. Contact support for more info.'}
					</span>
				</FlexRow>
				{isManualRejection && rejected_by ? (
					<FlexRow style={{ padding: '0.25rem 1rem 0', fontSize: '12px' }}>Rejected by: {rejected_by}</FlexRow>
				) : null}
				{!isManualRejection && ai_review_completed_at ? (
					<FlexRow style={{ padding: '0.25rem 1rem 0', fontSize: '12px' }}>Result published: {new Date(ai_review_completed_at).toLocaleString()}</FlexRow>
				) : null}
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button primary outline disabled={clearing} onClick={() => onFalse()}>
						Cancel
					</Button>
					<ButtonWithLoader error loading={clearing} onClick={() => onClearHandler()}>
						Clear Error
					</ButtonWithLoader>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapFunctionsToProps = {
	clearRejectedInventoryItem,
};

export default connect(null, mapFunctionsToProps)(ViewRejectionDialogBox);
